import { compose } from "redux";
import withTranslations from "../../../../../../hocs/withTranslations";
import LandingTypography from "../../../../landingPage/pages/Homepage/components/LandingTypography";
import AlarmClockIcon from "./assets/alarm-clock.svg";
import React from "react";
import { COLORED_BOX_VARIANTS } from "../ColoredBox";
import getPriceAlertButtonVariantStyle from "../../../../../../lib/getPriceAlertButtonVariantStyle";

const PriceAlertButton = ({
  translate,
  onClick,
  ariaLabel,
  variant = COLORED_BOX_VARIANTS.YELLOW
}) => {
  return (
    <LandingTypography>
      <button
        aria-label={ariaLabel}
        onClick={onClick}
        className="px-2 py-1 flex flex-row align-center gap-1.5 rounded-1 border-none hover:opacity-65 focus:opacity-80"
        style={getPriceAlertButtonVariantStyle(variant)}
      >
        <img
          src={AlarmClockIcon}
          alt={""}
          className={"shrink-0"}
          width={16}
          height={16}
        />
        <span className={"text-xs font-semibold line-height-100 text-black-8"}>
          {translate("new-price-alert-modal_title")}
        </span>
      </button>
    </LandingTypography>
  );
};

export default compose(withTranslations)(PriceAlertButton);
